import { Route } from 'react-router'
import { SettingsAccount } from '@/features/settings/account'
import { SettingsLanguage } from '@/features/settings/language'
import { SettingsLlm } from '@/features/settings/llm'
import { SettingsOrganization } from '@/features/settings/organization'
import { SettingsTheme } from '@/features/settings/theme'
import { SettingsFullAccessRoute } from './SettingsFullAccessRoute'

export function getSettingsChildRoutes() {
  return (
    <>
      <Route path='account' element={<SettingsAccount />} />
      <Route
        path='organization'
        element={
          <SettingsFullAccessRoute>
            <SettingsOrganization />
          </SettingsFullAccessRoute>
        }
      />
      <Route
        path='llm'
        element={
          <SettingsFullAccessRoute>
            <SettingsLlm />
          </SettingsFullAccessRoute>
        }
      />
      <Route path='theme' element={<SettingsTheme />} />
      <Route path='language' element={<SettingsLanguage />} />
    </>
  )
}
